import {
    Input
} from 'shared/components/ui/input';
import React, {
    useEffect, useState
} from 'react';

const SearchItems = ({
    items, handleFilterItems, placeholder = 'Search opcodes...'
}) => {
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        handleFilterItems(searchTerm);
    }, [items]);

    return (
        <div className="flex gap-2 items-center w-full">
            {/* <Search className="w-5 h-5" /> */}
            <Input
                type="text"
                placeholder={placeholder}
                value={searchTerm}
                onChange={(e) => {
                    setSearchTerm(e.target.value);
                    handleFilterItems(e.target.value);
                }}
                className="w-full mx-auto"
            />
        </div>
    );
};

export default SearchItems;